import { FunctionComponent } from 'react';

import useSession from '@tcs/client-portal-common/hooks/useSession';
import Admin from '@tcs/client-portal-admin/Admin';
import Representative from '@tcs/client-portal-representative/Representative';
import Individual from '@tcs/client-portal-individual/Individual';
import { Persona } from '@tcs/client-portal-api/types/Persona';
import Spinner from '@tcs/common/components/atoms/Spinner';
import { useStyles } from './style';

const personaMapping: { [key in Persona]?: FunctionComponent } = {
  [Persona.Admin]: Admin,
  [Persona.Representative]: Representative,
  [Persona.Individual]: Individual,
};

const renderPersona = (persona: Persona) => {
  const Component = personaMapping[persona] ?? Individual;
  return <Component />;
};

const PersonaSelector = () => {
  const { loading, claims } = useSession();
  const classes = useStyles();

  if (loading || claims === undefined) {
    return <Spinner className={classes.loadingWrapper} />;
  }

  return renderPersona(claims?.clientPortalPersona);
};

export default PersonaSelector;
